import { render, staticRenderFns } from "./UploadCard.html?vue&type=template&id=4a392c36&scoped=true&"
import script from "./UploadCard.js?vue&type=script&lang=js&"
export * from "./UploadCard.js?vue&type=script&lang=js&"
import style0 from "./UploadCard.scss?vue&type=style&index=0&id=4a392c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a392c36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
